<template>
  <div class="my-works--cards-point">

    <div class="my-works--cards-point-status">
      <div
        v-if="item.status === 'approved'"
        class="my-works--cards-point-status--label label-green"
      >
        Подтвержден
      </div>
      <div
        v-else-if="item.status === 'adminReview'"
        class="my-works--cards-point-status--label label-orange"
      >
        На проверке
      </div>
      <div
        v-else-if="item.status === 'declined'"
        class="my-works--cards-point-status--label label-red"
      >
        Отклонен
      </div>
      <v-icon v-if="item.is_visible" title="Публичная работа">mdi-flag</v-icon>
<!--      <div class="my-works&#45;&#45;cards-point-status&#45;&#45;button">-->
<!--        <v-btn v-if="false" icon class="more-btn">-->
<!--          <img src="@/assets/images/ico-points.svg" alt="" />-->
<!--        </v-btn>-->
<!--      </div>-->
    </div>

    <div class="my-works--cards-point-img">
      <img
        v-if="item.photos && item.photos.length"
        :src="item.photos[0].url"
        alt=""
      />
    </div>
    <div class="my-works--cards-point-location" style="position: relative">
      <div class="portfolio--cards-point-title">{{ item.title }}</div>
      <div class="portfolio--cards-point-location">
        <img src="@/assets/images/ico-location.svg" alt="" />
        <span>{{ item.city ? item.city.title : "" }}</span>
      </div>
    </div>
    <v-btn @click="$emit('edit', 1)" class="portfolio--cards-point-more">Подробнее</v-btn>
  </div>
</template>

<script>
export default {
  name: 'PortfolioItem',
  props: ['item', 'editable'],
};
</script>
